import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  IconButton,
  TextField,
  CircularProgress,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import PatientSearchBar from '../PatientSearchBar';
import MobileDetect from 'mobile-detect';
import Switch from '@material-ui/core/Switch';
import Button from '../../components/Button';
import ProviderSearchBar from '../../components/ProviderSearchBar';
import PDFSingleViewer from '../PDFSingleViewer';
import ImgSingleViewer from '../ImgSingleViewer';
import NoticeDialog from '../../components/DialogModals/NoticeDialog';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {
  makeS3BlobsRenderable,
  fileSelectHandler,
} from '../../util/fileHandling';
import { fetchConsultNoteAttachments } from '../../services/api';
import * as authApi from '../../services/api/auth';
import './styles.css';
import Backgroundscroll from '../../Backgroundscroll';
function ConsultNoteEditModal(props) {
  const {
    userId,
    viewOnly,
    note = {},
    patient = {},
    open,
    save,
    update,
    onClose,
    classes: {
      actions,
      input,
      modal,
      modalContent,
      selectInput,
      previewImg,
      btnSpacing,
      customFloatLeft,
      button,
      loading,
      customAttachmentView,
    },
  } = props;
  //const update = this.props.update !== undefined ? this.props.update : ''

  const [currentUser, setCurrentUser] = useState({});
  const [toProvider, setToProvider] = useState({});
  const [fromProvider, setFromProvider] = useState({});
  const [toPatientId, setToPatientId] = useState('');
  const [body, setBody] = useState(note.body);
  const [sendToQwellProviderName, setSendToQwellProviderName] = useState('');
  const [sendToQwellProviderNpi, setSendToQwellProviderNpi] = useState('');
  const [sendToQwell, setSendToQwell] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [images, setImages] = useState([]);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [openImgModal, setOpenImgModal] = useState(false);
  const [currentPDF, setCurrentPDF] = useState([]);
  const [currentImg, setCurrentImg] = useState('');
  const [popNotice, setPopNotice] = useState('');
  const [state, setState] = React.useState(false);
  const [patientVisibility, setPatientVisibility] = React.useState(false);
  const [imagePreview, setImagePreview] = React.useState(true);

  const myRef = useRef(null);

  useEffect(() => {
    let formattedToProvider = {};
    let formattedFromProvider = {};
    if (note.toProviderId) {
      formattedToProvider = {
        value: note.toProviderId,
        label: note.toProviderName,
      };
    }
    if (note.fromProviderId) {
      formattedFromProvider = {
        value: note.fromProviderId,
        label: note.fromProviderName,
      };
    }
    if (note.sendToQwell) {
      formattedToProvider = { value: 'send-to-qwell', label: 'Send to Qwell' };
    }
    setToProvider(formattedToProvider);
    setFromProvider(formattedFromProvider);
    setToPatientId(patient.id || note.patientId);
    setSendToQwellProviderName(note.sendToQwellProviderName);
    setSendToQwellProviderNpi(note.sendToQwellProviderNpi);
    setSendToQwell(note.sendToQwell);
  }, []);

  const handleOpenPDF = link => {
    setOpenPDFModal(true);
    setCurrentPDF(link);
  };
  const handleChange = () => {
    if (state) setState(false);
    else setState(true);
  };

  const handleOpenImg = link => {
    setOpenImgModal(true);
    setCurrentImg(link);
  };

  useEffect(() => {
    (async () => {
      const user = await authApi.fetchCurrentUser();
      setCurrentUser(user);
      if (note.fromProviderName === userId && note.visibility) {
        setState(true);
      }
      if (note.toProviderName === userId && note.visibility) {
        setPatientVisibility(true);
      }
      if (viewOnly) {
        // attaching documents for upload
        const apiResponse = await fetchConsultNoteAttachments(note.id);

        const imageObjects = makeS3BlobsRenderable(apiResponse.data);

        setImages(imageObjects);
      }
    })();
  }, []);

  const onFieldChange = e => {
    setValidationErrors({ ...validationErrors, [e.target.name]: false });
    switch (e.target.name) {
      case 'body':
        setBody(e.target.value);
        break;
      case 'sendToQwellProviderName':
        setSendToQwellProviderName(e.target.value);
        break;
      case 'sendToQwellProviderNpi':
        setSendToQwellProviderNpi(e.target.value);
        break;
      default:
        throw Error('unknown field changed');
    }
  };

  const inputPicCallBack = fileObject => {
    setImages(fileObject);
    fileObject.map(fileObjectOrStatusCode => {
      if (fileObjectOrStatusCode < 0 && fileObjectOrStatusCode >= -2) {
        const notice =
          fileObjectOrStatusCode === -1
            ? 'Max file size is 2 MB'
            : 'Please use a valid file to upload';
        setPopNotice(notice);
        myRef.current.value = null;
        setImages([]);
      }
    });
  };

  const validate = () => {
    let valid = true;
    const nextState = {};

    if (!toProvider.id) {
      nextState.toProvider = 'Required';
      valid = false;
    }
    if (!fromProvider.id && !currentUser.isProvider) {
      nextState.fromProvider = 'Required';
      valid = false;
    }
    if (!body) {
      nextState.body = 'Required';
      valid = false;
    }
    if (!sendToQwellProviderName && sendToQwell) {
      nextState.sendToQwellProviderName = 'Required';
      valid = false;
    }
    if (!(toPatientId || patient.id)) {
      nextState.toPatientId = 'Required';
      valid = false;
    }

    setValidationErrors(nextState);
    return valid;
  };

  const onSave = () => {
    save({
      body,
      patientId: toPatientId || patient.id, // this was sort of inexplicable, react is doing something funky that made this necessary
      toProviderId: toProvider.id,
      fromProviderId: currentUser.isAdministrator
        ? fromProvider.id
        : currentUser.isProvider
        ? currentUser.provider.id
        : null,
      sendToQwell,
      sendToQwellProviderName,
      sendToQwellProviderNpi,
      // currentUser,
      attachments: images.map(i => i.dataUrl),
      visibility: state,
      requestingAppt: false,
    });
    onClose();
  };

  const updateNote = () => {
    setPatientVisibility(false);
    update({
      id: note.id,
      visibility: state,
      patientId: toPatientId || patient.id, // this was sort of inexplicable, react is doing something funky that made this necessary
    });
    onClose();
  };

  const callSetImage = event => {
    setImages([]);
    fileSelectHandler(
      event.target.files,
      inputPicCallBack,
      ['jpg', 'jpeg', 'pdf'],
      1048576 // 1048576 bytes = 1MBl
    );
  };

  const download = file => {
    console.log('file', file);
  };

  /**
   * Book appointment function redirect to send To (Provider)
   */
  const handleBookAppointment = (e, toProviderUrl) => {
    if(!toProviderUrl){
      return;
    }
    e.stopPropagation();
    window.location.assign(
      `${process.env.REACT_APP_HOMEPAGE_URL}${toProviderUrl}`
    );
  };

  const renderPatient = () =>
    viewOnly || patient.id ? (
      <TextField
        inputProps={{
          disabled: true,
        }}
        label="Patient"
        variant="filled"
        fullWidth
        value={patient.name || note.patientName}
        className={selectInput}
      />
    ) : (
      <PatientSearchBar
        errorMessage={validationErrors.toPatientId}
        onSelect={patient => {
          if (patient) {
            setValidationErrors({ ...validationErrors, toPatientId: false });
            setToPatientId(patient.id);
          } else {
            setToPatientId(null);
          }
        }}
      />
    );

  const renderToProvider = () =>
    viewOnly ? (
      <TextField
        inputProps={{
          disabled: true,
        }}
        label="Send To (Provider)"
        variant="filled"
        fullWidth
        value={toProvider.label}
        className={selectInput}
      />
    ) : (
      <ProviderSearchBar
        label="Send To (Provider)"
        name="toProvider"
        placeholder="Search for a provider..."
        allowSendToQwell
        errorMessage={validationErrors.toProvider}
        onSelect={provider => {
          if (provider) {
            setValidationErrors({ ...validationErrors, toProvider: false });
            setSendToQwell(provider.id === 'send-to-qwell');
          }
          setToProvider(provider || {});
        }}
        className={selectInput}
      />
    );

  const renderFromProvider = () =>
    viewOnly ? (
      <TextField
        inputProps={{
          disabled: true,
        }}
        label="On Behalf Of (Provider)"
        variant="filled"
        fullWidth
        value={fromProvider.label}
        className={selectInput}
      />
    ) : (
      <ProviderSearchBar
        label="On Behalf Of (Provider)"
        name="fromProvider"
        placeholder="Search for a provider..."
        practiceId="currentUsersPracticeId"
        onSelect={provider => {
          setValidationErrors({ ...validationErrors, fromProvider: false });
          setFromProvider(provider || {});
        }}
        errorMessage={validationErrors.fromProvider}
        className={selectInput}
      />
    );

  const md = new MobileDetect(window.navigator.userAgent);
  const isMobile = md.mobile();
  return (
    <>
      <Dialog
        fullWidth
        open={open}
        onClose={onClose}
        classes={{ paper: modal }}
        maxWidth={'md'}
      >
        <DialogTitle className="smallHeading">
          <Grid container alignItems="center">
            <Grid item xs={11}>
              <h2>
                Message {!viewOnly ? 'a Doc' : ''}{' '}
                {patientVisibility ? '(Message visible to Patient)' : ''}
              </h2>
            </Grid>

            <Grid item xs={1}>
              <IconButton aria-label="Close" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent classes={{ root: modalContent }}>
          {renderPatient()}
          {renderToProvider()}
          {currentUser.provider &&
            !currentUser.provider.id &&
            renderFromProvider()}
          {(!viewOnly || note.fromProviderName === userId) && (
            <FormGroup row>
              <FormControlLabel
                className="switchToggle"
                control={<Switch checked={state} onChange={handleChange} />}
                label="Message visible to patient"
              />
            </FormGroup>
          )}

          {sendToQwell && (
            <>
              <div className="textFld">
                <TextField
                  disabled={viewOnly}
                  fullWidth
                  variant="outlined"
                  label="Provider Name"
                  helperText="We need the name of the person you want us to send this to."
                  name="sendToQwellProviderName"
                  value={sendToQwellProviderName}
                  onChange={onFieldChange}
                  error={validationErrors.sendToQwellProviderName}
                  // helperText={validationErrors.sendToQwellProviderName}
                  className={input}
                />
              </div>
              <TextField
                disabled={viewOnly}
                fullWidth
                variant="outlined"
                label="Provider NPI"
                helperText="An NPI will help us make sure it goes to the right person. (Optional)"
                name="sendToQwellProviderNpi"
                value={sendToQwellProviderNpi}
                onChange={onFieldChange}
                className={input}
              />
            </>
          )}
          <TextField
            inputProps={{
              disabled: viewOnly,
            }}
            fullWidth
            multiline
            rows="5"
            variant="outlined"
            label="Body"
            name="body"
            value={viewOnly ? note.body : body}
            onChange={onFieldChange}
            error={validationErrors.body}
            helperText={validationErrors.body}
            className={input}
          />
          {viewOnly ? (
            <div className="bok-appoint">
              <Button
                onClick={event =>
                  handleBookAppointment(event, note.toProviderUrl)
                }
                className={button}
              >
                Book Appointment
              </Button>
            </div>
          ) : (
            ''
          )}
          {!viewOnly && (
            <>
              <div className="fileName">
                <input
                  type="file"
                  ref={myRef}
                  multiple
                  onChange={event => callSetImage(event)}
                />
              </div>
              <br />
            </>
          )}
          <DialogContent classes={{ root: modalContent }}>
            {images && images.length == 0 ? (
              <div className={props.classes.loading} />
            ) : (
              images.map((image, index) =>
                image?.fileType === 'pdf' ? (
                  <>
                    <div className={btnSpacing}>
                      <span>{index + 1 + '.'}</span> &nbsp;&nbsp;
                      <Button
                        color="primary"
                        disabled={
                          image?.fileType === 'htm' ||
                          image?.fileType === 'html;base6'
                        }
                        variant="contained"
                        //    onClick={() => handleOpenPDF(image.dataUrl)}
                      >
                        Pdf File
                      </Button>
                      <div>
                        To see full report, please click download button
                      </div>
                      <a
                        className="custom-popup-download-btn"
                        target="_blank"
                        href={image && image.dataUrl}
                        download
                      >
                        Download PDF
                      </a>
                    </div>
                    <PDFSingleViewer
                      openPDFModal={openPDFModal}
                      currentPDF={currentPDF}
                      onClose={() => setOpenPDFModal(false)}
                    />
                  </>
                ) : (
                  <div className="customAttachmentView">
                    <Grid container className={customFloatLeft} item xs={6}>
                      <Grid className={btnSpacing} item xs={12}>
                        <span>{index + 1 + '.'}</span> &nbsp;&nbsp;
                        <Button
                          className="attactment-enlarge-btn"
                          color="primary"
                          // disabled={image ?.fileType === 'htm' || image ?.fileType === 'html' || image ?.fileType === 'html;base6'}
                          variant="contained"
                          onClick={
                            image?.fileType === 'htm' ||
                            image?.fileType === 'html' ||
                            image?.fileType === 'html;base6'
                              ? null
                              : () => handleOpenImg(image.dataUrl)
                          }
                        >
                          {image?.fileType === 'htm' ||
                          image?.fileType === 'html' ||
                          image?.fileType === 'html;base6'
                            ? 'Html File'
                            : '   Click to enlarge'}
                        </Button>
                        {/* <Button
                                                            color="primary"
                                                            disabled={image ?.fileType === 'htm' || image ?.fileType === 'html' || image ?.fileType === 'html;base6' }
                                                            variant="contained"
                                                            onClick={() => handleOpenImg(image.dataUrl)}
                                                        >
                                                            Click to enlarge
                                                            </Button> */}
                        {image?.fileType === 'htm' ||
                        image?.fileType === 'html' ||
                        image?.fileType === 'html;base6' ? (
                          <div>
                            To see full report, please click download button
                          </div>
                        ) : (
                          <img
                            src={image && image.dataUrl}
                            key={`picture-${index}`}
                            className={previewImg}
                          />
                        )}
                        <a
                          className="custom-popup-download-btn"
                          target="_blank"
                          href={image && image.dataUrl}
                          download
                        >
                          {image?.fileType === 'htm' ||
                          image?.fileType === 'html' ||
                          image?.fileType === 'html;base6'
                            ? 'DOWNLOAD HTML'
                            : 'DOWNLOAD IMAGES'}
                        </a>
                        {/* <img src={image &&  image.dataUrl} key={`picture-${index}`} className={previewImg} /> */}
                        {/* <img src={image &&  image.dataUrl} key={`picture-${index}`} alt="To see full report, please download the file" className={previewImg} /> */}
                        {/* <img src={image.dataUrl} key={`picture-${index}`} alt="preview" className={previewImg} /> */}
                        <ImgSingleViewer
                          openImgModal={openImgModal}
                          currentImg={currentImg}
                          onClose={() => setOpenImgModal(false)}
                        />
                      </Grid>
                    </Grid>
                  </div>
                )
              )
            )}
          </DialogContent>

          <Grid container classes={{ container: actions }}>
            {(!viewOnly ||
              (note &&
                note.fromProviderName === userId &&
                userId !== undefined)) && (
              <Grid item xs={12} lg={12}>
                <Button
                  className="custom-update-btn"
                  disabled={false}
                  fullWidth
                  color="primary"
                  variant="contained"
                  onClick={
                    note &&
                    note.fromProviderName === userId &&
                    userId !== undefined
                      ? updateNote
                      : onSave
                  }
                  onClickValidation={
                    note &&
                    note.fromProviderName === userId &&
                    userId !== undefined
                      ? ''
                      : validate
                  }
                >
                  {note &&
                  note.fromProviderName === userId &&
                  userId !== undefined
                    ? 'Update Note'
                    : 'Send Note'}
                </Button>
              </Grid>
            )}
          </Grid>
        </DialogContent>
      </Dialog>
      {popNotice && (
        <NoticeDialog
          open={popNotice}
          onOkClick={() => setPopNotice('')}
          noticeTitle="Notice"
          message={popNotice}
        />
      )}
    </>
  );
}

ConsultNoteEditModal.propTypes = {
  viewOnly: PropTypes.bool,
  note: PropTypes.object,
  patient: PropTypes.object,
  open: PropTypes.bool.isRequired,
  save: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
  },
  input: {
    margin: '0.5em 0',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
  button: {
    backgroundColor: '#0277bd',
    color: 'white',
    '&:visited': {
      color: 'white',
    },
  },
  previewImg: {
    maxWidth: 300,
    maxHeight: 300,
    display: 'block',
    margin: ' 1em 0',
  },
  btnSpacing: {
    marginBottom: '15px',
  },
  customFloatLeft: {
    width: '50%',
    display: 'inline-block',
  },
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default Backgroundscroll(withStyles(styles)(ConsultNoteEditModal));
